import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ErrorModule } from '../errors';
import { InputComponent, InputTagComponent } from './components';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        ReactiveFormsModule,

        ErrorModule,
    ],
    declarations: [
        InputComponent,
        InputTagComponent,
    ],
    providers: [
        {
            provide: 'window',
            useValue: window,
        },
    ],
    exports: [
        InputComponent,
        InputTagComponent,
    ],
})

export class InputModule {}
